// extracted by mini-css-extract-plugin
export default {"container":"CE","promoapplied":"EE","tobeapplied":"FE","hr":"GE","teal":"HE","promoappliedcontainer":"IE","error":"JE","input":"KE","errorInput":"LE","promo_x":"ME","promo_info":"NE","promoxcontainer":"OE"};
    if(module.hot) {
      // 1711394578644
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  